import { ADDRESSES } from "./contracts";

export function getOpenSeaItemUrl(tokenId: number) {
  return `https://opensea.io/item/robinhood/${ADDRESSES.CatStonks.toLowerCase()}/${tokenId}`;
}
